import React, { useEffect, useRef } from 'react';
import { Modal } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';

const SUCCESS_MESSAGE = `You are all set! CODiii is now verified for your company use.

For next Steps,

Copy your intended Sharepoint link: (Looks like "https://[tenant].sharepoint.com/sites/[SiteName]")
Go to SharePoint Admin Center
Open Advanced → API access
Open Pending requests (or App access, wording varies by company)
Find CODiii and Approve access for the site above

Hope your time hanging out with CODiii! :)`;

export default function MicrosoftAdminConsentComplete() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const shownRef = useRef(false);

  useEffect(() => {
    if (shownRef.current) return;
    shownRef.current = true;

    const adminConsent = searchParams.get('admin_consent');
    const isSuccess = adminConsent === 'True' || adminConsent === 'true';
    const isDenied = adminConsent === 'False' || adminConsent === 'false';

    const goHome = () => navigate('/', { replace: true });

    if (isDenied) {
      Modal.warning({
        title: 'Setup not completed',
        content: 'Microsoft admin consent was not granted. Please try again or contact your IT administrator.',
        okText: 'Close',
        onOk: goHome,
      });
      return;
    }

    Modal.success({
      title: isSuccess ? 'Microsoft setup complete' : 'CODiii Microsoft setup',
      content: <div style={{ whiteSpace: 'pre-line', lineHeight: 1.55 }}>{SUCCESS_MESSAGE}</div>,
      width: 580,
      okText: 'Got it',
      onOk: goHome,
    });
  }, [navigate, searchParams]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Montserrat, sans-serif',
        color: '#6b7280',
      }}
    >
      Loading…
    </div>
  );
}
